import { HomeOnlineExamPage } from './HomeOnlineExamPage';
export default HomeOnlineExamPage;
